import { DOCUMENT, inject, Injectable, signal } from '@angular/core';

export const UI_THEMES = ['passenger', 'movilidad'] as const;
export type UiTheme = (typeof UI_THEMES)[number];

/**
 * El tema vive en `data-theme` de `<html>`: los tokens de componente se resuelven ahí. Cada shell lo
 * fija en su `index.html`, así que el primer pintado ya sale con su marca; este servicio sólo hace
 * falta para cambiarlo en caliente, como en la galería.
 */
@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly root = inject(DOCUMENT).documentElement;
  private readonly current = signal<UiTheme>(this.read());

  readonly theme = this.current.asReadonly();

  set(theme: UiTheme): void {
    this.root.setAttribute('data-theme', theme);
    this.current.set(theme);
  }

  private read(): UiTheme {
    const value = this.root.getAttribute('data-theme');
    return UI_THEMES.find((theme) => theme === value) ?? 'passenger';
  }
}
